
type KernCijfers = Record<number, {
    winst: string;
    omzet: string;
    eigen_vermogen: string;
    bruto_marge: string;
    balanstotaal: string;
    totale_schulden: string;
}>

interface KernCijfer {
    color: Color;
    hasNoValues: boolean;
    isActive: boolean;
    label: string;
    valuesPerYear: Record<number, number>
}

interface HoveredElement {
    bgColor: Color;
    x: number;
    y: number;
    value: number;
}

interface ChartData {
    winst: KernCijfer;
    omzet: KernCijfer;
    brutoMarge: KernCijfer;
    eigenVermogen: KernCijfer;
    balansTotaal: KernCijfer;
    totaleSchulden: KernCijfer;
}

interface Line {
    valStart: number,
    valEnd: number,
    year: number
}

interface IChartNode {
    val: number;
    yPos: number;
    xPos: number;
}

enum Color {
    LILA = "lila",
    RED = "red",
    BLUE = "blue",
    TEAL = "teal",
    YELLOW = "yellow",
    PINK = "pink",
    CYAN = "cyan",
    TRANSPARENT = "transparent"
}

const ColorMap: Record<Color, {fill: string, accent: string, stroke: string, background: string}> = {
    [Color.LILA]: {
        fill: "fill-lila-500",
        accent: "accent-lila-500",
        stroke: "stroke-lila-500",
        background: "bg-lila-500",
    },
    [Color.RED]: {
        fill: "fill-rust-500",
        accent: "accent-rust-500",
        stroke: "stroke-rust-500",
        background: "bg-rust-500",
    },
    [Color.BLUE]: {
        fill: "fill-primary-500",
        accent: "accent-primary-500",
        stroke: "stroke-primary-500",
        background: "bg-primary-500",
    },
    [Color.TEAL]: {
        fill: "fill-pine-500",
        accent: "accent-pine-500",
        stroke: "stroke-pine-500",
        background: "bg-pine-500",
    },
    [Color.YELLOW]: {
        fill: "fill-barometer-yellow",
        accent: "accent-barometer-yellow",
        stroke: "stroke-barometer-yellow",
        background: "bg-barometer-yellow",
    },
    [Color.PINK]: {
        fill: "fill-pink-500",
        accent: "accent-pink-500",
        stroke: "stroke-pink-500",
        background: "bg-pink-500",
    },
    [Color.CYAN]: {
        fill: "fill-cyan-500",
        accent: "accent-cyan-500",
        stroke: "stroke-cyan-500",
        background: "bg-cyan-500",
    },
    //TODO
    [Color.TRANSPARENT]: {
        fill: "fill-transparent",
        accent: "accent-transparent",
        stroke: "stroke-transparent",
        background: "bg-transparent",
    },
}

export {
    KernCijfer,
    ChartData,
    Line,
    IChartNode,
    Color,
    ColorMap,
    KernCijfers,
    HoveredElement
}